export const useRewardsResponseSchema = {
	type: 'array',
	items: {
		type: 'string',
	},
}
